module.exports = __webpack_public_path__ + "static/media/andrew_miklas.dbf66720.png";